import { Controller } from 'stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = ['duration'];

  connect() {
    this.service = this.element.querySelector('.tracker-panel__dropdown--category');
    if (this.service) {
      $(this.service).selectize();
    }

    $(this.durationTarget).inputmask('99:99', {
      placeholder: '00:00',
      showMaskOnHover: false,
      onKeyDown(event) {
        const input = event.currentTarget;
        const value = input.value;
        const key = event.key;

        if (/^\d$/.test(key) && value.length > 4) {
          const selectionStart = input.selectionStart;
          const newValue = `${value.substring(0, selectionStart)}${key}${value.substring(
            selectionStart + 1
          )}`;

          input.value = newValue;
          const newSelectionStart = selectionStart + (selectionStart === 2 ? 2 : 1);
          input.setSelectionRange(newSelectionStart, newSelectionStart);

          event.preventDefault();
        }
      },
    });
  }

  disconnect() {
    this.service?.selectize?.destroy();
    $(this.durationTarget).inputmask('remove');
  }

  carryOverMinutes() {
    const [hours, minutes] = this.durationTarget.value.split(':').map(Number);
    if (minutes > 59) {
      // 99 hours is the most the mask holds
      this.durationTarget.value =
        hours === 99 ? '99:59' : formatDuration(hours + Math.floor(minutes / 60), minutes % 60);
    }
  }
}

const formatDuration = (hours, minutes) =>
  `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
